/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M14 2.5V4.80003C14 5.92013 14 6.48019 14.218 6.90801C14.4097 7.28433 14.7157 7.5903 15.092 7.78204C15.5198 8.00003 16.0799 8.00003 17.2 8.00003H19.5M6 19V16M10 22V16M14 22V16M18 19V16"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M4 12V9.77817C4 7.18697 4 5.89136 4.46859 4.88663C4.96536 3.82147 5.82147 2.96536 6.88663 2.46859C7.89136 2 9.18697 2 11.7782 2V2C12.9105 2 13.4766 2 14.0113 2.11855C14.5806 2.24479 15.1235 2.46965 15.6153 2.78296C16.0772 3.07721 16.4775 3.47753 17.2782 4.27817L17.6569 4.65685C18.5216 5.52161 18.954 5.95399 19.2632 6.45858C19.5373 6.90594 19.7394 7.39366 19.8618 7.90384C20 8.47928 20 9.09076 20 10.3137V12M2 12H22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M11 2C11.9319 2 12.3978 2 12.7654 2.15225C13.2554 2.35523 13.6448 2.74457 13.8478 3.23462C14 3.60217 14 4.06812 14 5.00002C14 5.93191 14 6.39785 14.1522 6.7654C14.3552 7.25545 14.7446 7.6448 15.2346 7.84779C15.6022 8.00003 16.0681 8.00003 17 8.00003C17.9319 8.00003 18.3978 8.00003 18.7654 8.15227C19.2554 8.35526 19.6448 8.74461 19.8478 9.23466C20 9.6022 20 10.0681 20 11V12H4V8.4C4 6.15979 4 5.03969 4.43597 4.18404C4.81947 3.43139 5.43139 2.81947 6.18404 2.43597C7.03969 2 8.15979 2 10.4 2H11Z"
				fill="currentColor"
			/>
			<path
				d="M4 12V9.77817C4 7.18697 4 5.89136 4.46859 4.88663C4.96536 3.82147 5.82147 2.96536 6.88663 2.46859C7.89136 2 9.18697 2 11.7782 2V2C12.9105 2 13.4766 2 14.0113 2.11855C14.5806 2.24479 15.1235 2.46965 15.6153 2.78296C16.0772 3.07721 16.4775 3.47753 17.2782 4.27817L17.6569 4.65685C18.5216 5.52161 18.954 5.95399 19.2632 6.45858C19.5373 6.90594 19.7394 7.39366 19.8618 7.90384C20 8.47928 20 9.09076 20 10.3137V12M2 12H22M6 19V16M10 22V16M14 22V16M18 19V16M14 2.5V6.00003C14 7.1046 14.8954 8.00003 16 8.00003V8.00003H17"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.25 3.95001V1.25H11.25C8.44974 1.25 7.04961 1.25 5.98005 1.79497C5.03924 2.27433 4.27433 3.03924 3.79497 3.98005C3.25 5.04961 3.25 6.44974 3.25 9.25V11.25H2C1.58579 11.25 1.25 11.5858 1.25 12C1.25 12.4142 1.58579 12.75 2 12.75H22C22.4142 12.75 22.75 12.4142 22.75 12C22.75 11.5858 22.4142 11.25 22 11.25H20.75V8.75001H18.05C16.3698 8.75001 15.5298 8.75001 14.888 8.42303C14.3235 8.13541 13.8646 7.67647 13.577 7.11198C13.25 6.47025 13.25 5.63017 13.25 3.95001ZM14.75 4.05001V1.25C15.109 1.25 15.4533 1.39261 15.7071 1.64645L20.3535 6.29288C20.6074 6.54673 20.75 6.89102 20.75 7.25001H17.95C16.8299 7.25001 16.2698 7.25001 15.842 7.03203C15.4657 6.84028 15.1597 6.53432 14.968 6.15799C14.75 5.73017 14.75 5.17012 14.75 4.05001ZM6.75 16C6.75 15.5858 6.41421 15.25 6 15.25C5.58579 15.25 5.25 15.5858 5.25 16V19C5.25 19.4142 5.58579 19.75 6 19.75C6.41421 19.75 6.75 19.4142 6.75 19V16ZM10.75 16C10.75 15.5858 10.4142 15.25 10 15.25C9.58579 15.25 9.25 15.5858 9.25 16V22C9.25 22.4142 9.58579 22.75 10 22.75C10.4142 22.75 10.75 22.4142 10.75 22V16ZM14.75 16C14.75 15.5858 14.4142 15.25 14 15.25C13.5858 15.25 13.25 15.5858 13.25 16V22C13.25 22.4142 13.5858 22.75 14 22.75C14.4142 22.75 14.75 22.4142 14.75 22V16ZM18.75 16C18.75 15.5858 18.4142 15.25 18 15.25C17.5858 15.25 17.25 15.5858 17.25 16V19C17.25 19.4142 17.5858 19.75 18 19.75C18.4142 19.75 18.75 19.4142 18.75 19V16Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M4 12V9.77817C4 7.18697 4 5.89136 4.46859 4.88663C4.96536 3.82147 5.82147 2.96536 6.88663 2.46859C7.89136 2 9.18697 2 11.7782 2V2C12.9105 2 13.4766 2 14.0113 2.11855C14.5806 2.24479 15.1235 2.46965 15.6153 2.78296C16.0772 3.07721 16.4775 3.47753 17.2782 4.27817L17.6569 4.65685C18.5216 5.52161 18.954 5.95399 19.2632 6.45858C19.5373 6.90594 19.7394 7.39366 19.8618 7.90384C20 8.47928 20 9.09076 20 10.3137V12M2 12H22M6 19V16M10 22V16M14 22V16M18 19V16M14 2.5V6.00003C14 7.1046 14.8954 8.00003 16 8.00003V8.00003H17"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M4 12V9.77817C4 7.18697 4 5.89136 4.46859 4.88663C4.96536 3.82147 5.82147 2.96536 6.88663 2.46859C7.89136 2 9.18697 2 11.7782 2V2C12.9105 2 13.4766 2 14.0113 2.11855C14.5806 2.24479 15.1235 2.46965 15.6153 2.78296C16.0772 3.07721 16.4775 3.47753 17.2782 4.27817L17.6569 4.65685C18.5216 5.52161 18.954 5.95399 19.2632 6.45858C19.5373 6.90594 19.7394 7.39366 19.8618 7.90384C20 8.47928 20 9.09076 20 10.3137V12M2 12H22M6 19V16M10 22V16M14 22V16M18 19V16M14 2.5V4.80003C14 5.92013 14 6.48019 14.218 6.90801C14.4097 7.28433 14.7157 7.5903 15.092 7.78204C15.5198 8.00003 16.0799 8.00003 17.2 8.00003H19.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M13.25 1.25V3.95001C13.25 5.63017 13.25 6.47025 13.577 7.11198C13.8646 7.67647 14.3235 8.13541 14.888 8.42303C15.5298 8.75001 16.3698 8.75001 18.05 8.75001H20.75V12H3.25V9.25C3.25 6.44974 3.25 5.04961 3.79497 3.98005C4.27433 3.03924 5.03924 2.27433 5.98005 1.79497C7.04961 1.25 8.44974 1.25 11.25 1.25H13.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.75 4.05001V1.25C15.109 1.25 15.4533 1.39261 15.7071 1.64645L20.3535 6.29288C20.6074 6.54673 20.75 6.89102 20.75 7.25001H17.95C16.8299 7.25001 16.2698 7.25001 15.842 7.03203C15.4657 6.84028 15.1597 6.53432 14.968 6.15799C14.75 5.73017 14.75 5.17012 14.75 4.05001ZM2 11.25C1.58579 11.25 1.25 11.5858 1.25 12C1.25 12.4142 1.58579 12.75 2 12.75H22C22.4142 12.75 22.75 12.4142 22.75 12C22.75 11.5858 22.4142 11.25 22 11.25H2ZM6.75 16C6.75 15.5858 6.41421 15.25 6 15.25C5.58579 15.25 5.25 15.5858 5.25 16V19C5.25 19.4142 5.58579 19.75 6 19.75C6.41421 19.75 6.75 19.4142 6.75 19V16ZM10.75 16C10.75 15.5858 10.4142 15.25 10 15.25C9.58579 15.25 9.25 15.5858 9.25 16V22C9.25 22.4142 9.58579 22.75 10 22.75C10.4142 22.75 10.75 22.4142 10.75 22V16ZM14.75 16C14.75 15.5858 14.4142 15.25 14 15.25C13.5858 15.25 13.25 15.5858 13.25 16V22C13.25 22.4142 13.5858 22.75 14 22.75C14.4142 22.75 14.75 22.4142 14.75 22V16ZM18.75 16C18.75 15.5858 18.4142 15.25 18 15.25C17.5858 15.25 17.25 15.5858 17.25 16V19C17.25 19.4142 17.5858 19.75 18 19.75C18.4142 19.75 18.75 19.4142 18.75 19V16Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
